/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconTrustFreeze = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...rest}
    >
      <path stroke="green" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m10.002 4 2 1 2-1m-2-2v6.5l3 1.72M17.926 6.268 18.06 8.5l1.866 1.232M20.658 7l-5.629 3.25.01 3.458M19.93 14.268 18.064 15.5l-.134 2.232M20.662 17l-5.63-3.25-2.989 1.738M13.998 20l-2-1-2 1m2 2v-6.5l-3-1.72M6.074 17.732 5.94 15.5l-1.866-1.232M3.342 17l5.629-3.25-.01-3.458M4.07 9.732 5.936 8.5l.134-2.232M3.338 7l5.63 3.25 2.989-1.738" />
    </svg>
  );
};
export default IconTrustFreeze;
